export default __webpack_public_path__ + "static/media/updated-ISMO.d47543e6.pdf";